import { render, staticRenderFns } from "./HubPageAudit.vue?vue&type=template&id=b65f415c&"
import script from "./HubPageAudit.vue?vue&type=script&lang=js&"
export * from "./HubPageAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports